var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudgetManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 7.3H13.6C13.4 6 12.9 4.9 12 4C11.1 3.1 10 2.6 8.7 2.4V7.3ZM7.3 13.6V2.4C5.9 2.6 4.7 3.2 3.8 4.2C2.9 5.2 2.4 6.5 2.4 7.9C2.4 9.3 2.9 10.6 3.8 11.6C4.7 12.7 5.9 13.3 7.3 13.4V13.6ZM8.7 13.6C10 13.4 11.1 12.9 12 12C12.9 11.1 13.4 10 13.6 8.7H8.7V13.6ZM8 15C7 15 6.1 14.8 5.3 14.4C4.5 14 3.7 13.5 3.1 12.9C2.5 12.3 2 11.5 1.6 10.7C1.2 9.9 1 8.9 1 8C1 7.1 1.2 6.1 1.6 5.3C2 4.5 2.5 3.7 3.1 3.1C3.7 2.5 4.5 2 5.3 1.6C6.1 1.2 7.1 1 8 1C8.9 1 9.9 1.2 10.7 1.6C11.5 2 12.3 2.5 12.9 3.1C13.5 3.7 14 4.5 14.4 5.3C14.8 6.1 15 7.1 15 8C15 8.9 14.8 9.9 14.4 10.7C14 11.5 13.5 12.3 12.9 12.9C12.3 13.5 11.5 14 10.7 14.4C9.9 14.8 8.9 15 8 15Z",
    fill: "#8E97A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetManagement);
export default __webpack_public_path__ + "static/media/budget-management.1a266fdad2136052fd5c0216c1513238.svg";
export { ForwardRef as ReactComponent };